module.exports = __webpack_public_path__ + "static/media/sofia.b5e8ea1c.png";